"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RSAA = '@@redux-async-middleware/RSAA';
var _default = RSAA;
exports.default = _default;